@if ($inputs().length > 0) {
    <cm-inspector-section>
        <ng-container cm-title>Inputs</ng-container>
        <ng-container cm-content>
            <div class="cm-component-settings">
                <ng-template #inputGroupTemplate let-group let-depth="depth" let-path="path">
                    <cm-list-item
                        [expandable]="true"
                        [expanded]="isInputGroupExpanded(path)"
                        [style.padding-left.px]="depth * 16"
                        (click)="toggleInputGroup(path)"
                        (arrowToggle)="toggleInputGroup(path)"
                    >
                        <span cm-title>{{ group.label }}</span>
                    </cm-list-item>
                    @if (isInputGroupExpanded(path)) {
                        @for (item of group.items; track item.descriptor.props.id) {
                            <div class="cm-component-setting" [style.padding-left.px]="depth * 16">
                                @if ($node(); as node) {
                                    @if (item.selectionPossibilities) {
                                        <cm-value-slot
                                            [node]="node"
                                            [key]="'parameters'"
                                            [subKey]="item.unwrappedId"
                                            [label]="item.label"
                                            [selectionPossibilities]="item.selectionPossibilities"
                                            [overwrittenValue]="item.overwrittenValue"
                                            [schema]="item.schema"
                                            (updatedOverwrittenValue)="onUpdateComponentInstanceParameter(item.unwrappedId, $event)"
                                        ></cm-value-slot>
                                    } @else {
                                        <cm-value-slot
                                            [node]="node"
                                            [key]="'parameters'"
                                            [subKey]="item.unwrappedId"
                                            [label]="item.label"
                                            [overwrittenValue]="item.overwrittenValue"
                                            [schema]="item.schema"
                                            (updatedOverwrittenValue)="onUpdateComponentInstanceParameter(item.unwrappedId, $event)"
                                        ></cm-value-slot>
                                    }
                                }
                                <i class="far fa-question-circle cm-info-icon" [matTooltip]="item.unwrappedId"></i>
                            </div>
                        }
                        @for (child of group.children; track child.label) {
                            <ng-container
                                [ngTemplateOutlet]="inputGroupTemplate"
                                [ngTemplateOutletContext]="{$implicit: child, depth: depth + 1, path: path + '/' + child.label}"
                            ></ng-container>
                        }
                    }
                </ng-template>

                @for (item of $groupedInputs().items; track item.descriptor.props.id) {
                    <div class="cm-component-setting">
                        @if ($node(); as node) {
                            @if (item.selectionPossibilities) {
                                <cm-value-slot
                                    [node]="node"
                                    [key]="'parameters'"
                                    [subKey]="item.unwrappedId"
                                    [label]="item.label"
                                    [selectionPossibilities]="item.selectionPossibilities"
                                    [overwrittenValue]="item.overwrittenValue"
                                    [schema]="item.schema"
                                    (updatedOverwrittenValue)="onUpdateComponentInstanceParameter(item.unwrappedId, $event)"
                                ></cm-value-slot>
                            } @else {
                                <cm-value-slot
                                    [node]="node"
                                    [key]="'parameters'"
                                    [subKey]="item.unwrappedId"
                                    [label]="item.label"
                                    [overwrittenValue]="item.overwrittenValue"
                                    [schema]="item.schema"
                                    (updatedOverwrittenValue)="onUpdateComponentInstanceParameter(item.unwrappedId, $event)"
                                ></cm-value-slot>
                            }
                        }
                        <i class="far fa-question-circle cm-info-icon" [matTooltip]="item.unwrappedId"></i>
                    </div>
                }
                @for (group of $groupedInputs().children; track group.label) {
                    <ng-container
                        [ngTemplateOutlet]="inputGroupTemplate"
                        [ngTemplateOutletContext]="{$implicit: group, depth: 0, path: group.label}"
                    ></ng-container>
                }
            </div>
        </ng-container>
    </cm-inspector-section>
}

@if ($outputs().length > 0) {
    <cm-inspector-section class="cm-outputs-section">
        <ng-container cm-title>Outputs</ng-container>
        <ng-container cm-content>
            <div class="cm-component-settings">
                <ng-template #outputGroupTemplate let-group let-depth="depth" let-path="path">
                    <cm-list-item
                        [expandable]="true"
                        [expanded]="isOutputGroupExpanded(path)"
                        [style.padding-left.px]="depth * 16"
                        (click)="toggleOutputGroup(path)"
                        (arrowToggle)="toggleOutputGroup(path)"
                    >
                        <span cm-title>{{ group.label }}</span>
                    </cm-list-item>
                    @if (isOutputGroupExpanded(path)) {
                        @for (item of group.items; track item.descriptor.props.id) {
                            <div class="cm-component-setting" [style.padding-left.px]="depth * 16">
                                <div
                                    class="cm-output-label"
                                    (click)="onComponentInstanceOutputItemClicked(item.descriptor)"
                                    [matTooltip]="'OutputRef: ' + item.label"
                                >
                                    <i class="far fa-sign-out-alt"></i>
                                    {{ item.label }}
                                </div>
                                <i class="far fa-question-circle cm-info-icon" [matTooltip]="item.unwrappedId"></i>
                            </div>
                        }
                        @for (child of group.children; track child.label) {
                            <ng-container
                                [ngTemplateOutlet]="outputGroupTemplate"
                                [ngTemplateOutletContext]="{$implicit: child, depth: depth + 1, path: path + '/' + child.label}"
                            ></ng-container>
                        }
                    }
                </ng-template>

                @for (item of $groupedOutputs().items; track item.descriptor.props.id) {
                    <div class="cm-component-setting">
                        <div class="cm-output-label" (click)="onComponentInstanceOutputItemClicked(item.descriptor)" [matTooltip]="'OutputRef: ' + item.label">
                            <i class="far fa-sign-out-alt"></i>
                            {{ item.label }}
                        </div>
                        <i class="far fa-question-circle cm-info-icon" [matTooltip]="item.unwrappedId"></i>
                    </div>
                }
                @for (group of $groupedOutputs().children; track group.label) {
                    <ng-container
                        [ngTemplateOutlet]="outputGroupTemplate"
                        [ngTemplateOutletContext]="{$implicit: group, depth: 0, path: group.label}"
                    ></ng-container>
                }
            </div>
        </ng-container>
    </cm-inspector-section>
}
